import { pathRedirect } from '@/utils/auth'

import Home from '@/containers/Dashboard/Home'
import BusinessCharges from '@/containers/Dashboard/BusinessCharges'
import LeakageControl from '@/containers/Dashboard/LeakageControl'
import MeterReading from '@/containers/Dashboard/MeterReading'
import WechatBusinessHall from '@/containers/Dashboard/WechatBusinessHall'

export default {
  path: 'dashboard',
  redirect: pathRedirect,
  children: [
    { path: 'home', component: Home },
    { path: 'businessCharges', component: BusinessCharges },
    { path: 'leakageControl', component: LeakageControl },
    { path: 'meterReading', component: MeterReading },
    { path: 'wechatBusinessHall', component: WechatBusinessHall }
  ],
  component: {
    template: '<router-view></router-view>'
  }
}



// WEBPACK FOOTER //
// ./src/router/dashboard.js